export const SINGLE_LINE_INPUT_MAX_LENGTH = 250;
export const TEXT_AREA_MAX_LENGTH = 500;
export const LARGE_TEXT_AREA_MAX_LENGTH = 3000;

// for report submission payload
export const ONLINE_CHANNEL = 'Online';
export const REACT_PLATFORM = 'React';

// for beforeyoustart page
export const FORM_LINK_TEXT = 'Fill in the form';
export const FORM_LINK_SUBTEXT = 'Send us the issue details using a form';
export const CHAT_LINK_TEXT = 'Use the Report it assistant';
export const CHAT_LINK_SUBTEXT =
  'Chat with our digital assistant to make your report';

// Website links
export const REPORT_IT_WEBSITE_LINK =
  'https://www.westminster.gov.uk/report-it';

// Text content
export const RETURN_TO_HOME_PAGE_TEXT = 'Return to homepage';
export const BACK_TO_HOME_PAGE_TEXT = 'Back to homepage';

// accepted file types for upload
export const ACCEPTED_FILE_TYPES = ['jpeg', 'png', 'jpg', 'gif', 'webp'];
export const ACCEPTED_FILE_TYPES_WITHOUT_GIF = ['jpeg', 'png', 'jpg', 'webp'];
export const ACCEPTED_FILE_TYPES_WITH_PDF = [
  'jpeg',
  'png',
  'jpg',
  'gif',
  'webp',
  'pdf',
];
